<template>
    <div class="transaction-history">
        <div class="transaction-history__header">
            <div class="transaction-history__header__plan-name">{{ planName }}</div>
            <a class="btn btn-primary btn-sb-red float-right transaction-history__header__export" @click="exportCSV">
                <span class="align-middle">Export</span>
            </a>
        </div>
        <div class="transaction-history-table transaction-history-table__header mt-4 d-md-none">
            <div class="table__code ml-3">Product Code</div>
            <div class="table__amount">Amount</div>
            <div class="table__edate">Effective Date</div>
            <div class="table__thrudate">Thru Date</div>
        </div>

        <div class="transaction-history-table transaction-history-table__body" v-for="payment in paginatedPayments">
            <div class="table__code ml-3"><div class="d-lg-none d-sm-block">Product Code</div> <div>{{ payment.description }}</div></div>
            <div class="table__amount"><div class="d-lg-none d-sm-block">Amount</div><div>{{ (payment.amount).toFixed(2)}}</div></div>
            <div class="table__edate"><div class="d-lg-none d-sm-block">Effective Date</div><div>{{ payment.eff_date }}</div></div>
            <div class="table__thrudate"><div class="d-lg-none d-sm-block">Thru Date</div><div>{{ payment.thru_date }}</div></div>
        </div>

        <pagination
            v-if="showPagination"
            :records="payments.length"
            v-model="page"
            :per-page="perPage"
            :options="options"
        ></pagination>
    </div>
</template>

<script>
import Pagination from "vue-pagination-2";

export default {
    name: "PaymentsHistory",
    props: ['planName', 'payments'],
    components: {
        Pagination
    },
    data() {
        return {
            jsonFields: {
                "Product Code": "description",
                "Amount": "amount",
                "Effective Date": "eff_date",
                "Thru Date": "thru_date"
            },
            options: {
                'chunk': 3
            },
            page: 1,
            perPage: 10,
            showPagination: this.payments.length > 5
        }
    },
    mounted() {
        if (this.showPagination) this.createSelectPerPage();
    },
    computed: {
        paginatedPayments() {
            const start = this.page * this.perPage - this.perPage;
            return this.payments.slice(start, start + this.perPage);
        }
    },
    methods: {
        createSelectPerPage() {
            const selectPerPage = document.createElement('select');
            selectPerPage.id = 'select-per-page';
            selectPerPage.name = 'select-per-page';
            selectPerPage.innerHTML = '<option value="5">5</option><option value="10" selected>10</option><option value="20">20</option><option value="50">50</option><option value="100">100</option>';
            selectPerPage.addEventListener('change', this.changePerPage, false);

            const infoBlock = document.getElementsByClassName('VuePagination__count')[0];
            infoBlock.parentNode.insertBefore(selectPerPage, infoBlock.nextSibling);
        },
        changePerPage() {
            this.page = 1;
            this.perPage = parseInt(document.getElementById('select-per-page').value);
        },
        exportCSV() {
            this.$http.post('/api/payments-csv', {
                payments: this.payments
            }).then(res => {
                const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' })
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = "payments";
                link.click()
                URL.revokeObjectURL(link.href)
            })
        }
    }
}
</script>

<style scoped>

</style>
